import building from 'plugins/i18n/entity/building.en.ts'
import meter from 'plugins/i18n/entity/meter.en.ts'
import common from 'plugins/i18n/common.en.ts'

const meterLevel = {
	name: 'Meter Reading',
	fields: {
		read_off_at: 'Read on',
		value: 'Meter reading',
		building: {
			name: building.name,
			...building.fields,
		},
		meter: {
			...meter.fields,
		},
		created: common.createdAt,
	},
}

export default meterLevel
